import { isListItemNode, isListNode } from '@atlaskit/editor-common/utils';
// This will return (depth - 1) for root list parent of a list.
export var getListLiftTarget = function getListLiftTarget(resPos) {
  var target = resPos.depth;
  for (var i = resPos.depth; i > 0; i--) {
    var node = resPos.node(i);
    if (isListNode(node)) {
      target = i;
    }
    if (!isListItemNode(node) && !isListNode(node)) {
      break;
    }
  }
  return target - 1;
};